export default __webpack_public_path__ + "static/media/therapy-kit.4481ad74.png";